import { motion } from "framer-motion";

const FEATURED = [
  { id: "bolt-vii", tag: "BOLT VII", sub: "Fiber Laser Cutting Machine", img: "https://www.laser-machines.com/images/pro01.webp" },
  { id: "swing", tag: "SWING VII 3015", sub: "Fiber Laser Cutting Machine", img: "https://www.laser-machines.com/images/pro02.webp" },
  { id: "bull-v-ce", tag: "BULL V Series", sub: "Large Format Fiber Laser Cutting Machine", img: "https://www.laser-machines.com/images/pro03.webp" },
  { id: "rhino", tag: "RHINO Series", sub: "H-Beam Laser Cutting Machine", img: "https://www.laser-machines.com/images/pro04.webp" },
  { id: "wpl", tag: "WPL Series", sub: "Laser Tube Cutting Machine", img: "https://www.laser-machines.com/images/pro05.webp" },
  { id: "gan-3d", tag: "GAN Series", sub: "3D Laser Cutting Machine", img: "https://www.laser-machines.com/images/pro06.webp" },
];

export default function Featured({ products, onSelect }) {
  const items = FEATURED.map((f) => ({ ...f, product: products.find((p) => p.id === f.id) })).filter((f) => f.product);
  return (
    <section id="featured" data-testid="featured-section" className="bg-white">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 lg:py-20">
        <h2 className="text-center text-3xl font-light uppercase tracking-wide text-[#222] sm:text-4xl" data-testid="featured-heading">
          Laser Cutting & Welding Equipment
        </h2>
        <p className="mx-auto mt-4 max-w-3xl text-center text-sm leading-relaxed text-muted-foreground">
          With a robust foundation of 17 years in the sheet metal industry, Penta Laser has established itself as a vanguard in the realm of laser cutting and welding equipment.
        </p>
        <div className="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((f, i) => (
            <motion.button
              key={f.id}
              data-testid={`featured-card-${f.id}`}
              onClick={() => onSelect(f.product)}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              className="group bg-white text-left shadow-[0_2px_12px_rgba(0,0,0,0.08)] transition-shadow duration-200 hover:shadow-[0_6px_24px_rgba(0,0,0,0.14)]"
            >
              <div className="relative overflow-hidden">
                <img src={f.img} alt={`${f.tag} - ${f.sub}`} loading="lazy" className="aspect-[4/3] w-full object-cover transition-transform duration-300 group-hover:scale-105" />
                <span className="absolute bottom-0 left-0 bg-laser px-3 py-1.5 text-xs font-semibold text-white">{f.tag}</span>
              </div>
              <div className="p-4">
                <h3 className="text-[15px] font-medium text-[#333] transition-colors group-hover:text-laser">{f.sub}</h3>
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
